import type { FaireProductEntity } from "../../entity_types/product";

export const p_8kq2fhrkk2: FaireProductEntity = {
  token: "p_8kq2fhrkk2",
  type: "product",
  name: "Twisted Knots & Rings Bangle Cuff Bracelet",
  brandToken: "b_nnzc8s53xn",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1eb747943ed0bf8ef131790dde3e01441ccf9f4e86e0e57930f67598a2e15d6f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f08da3fe4cb517c0c423dea6372441b03ec6e8e198d080788272ca2b3ea99f2.jpeg",
  ],
  priceDollars: 9,
  description:
    "Indulge in comfort and style with our women's bracelets – designed for every wrist, the one-size-fits-most flexibility ensures a perfect fit, effortlessly complementing your individuality.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:56.733Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
